export function getAppInfo() {
  const appInfoString = localStorage.getItem('appInfo')
  if (!appInfoString) {
    throw new Error('No appInfo found in localStorage')
  }
  const appInfo = JSON.parse(appInfoString)
  return appInfo
}
